import { useQuery } from 'react-query';

//APP
import { api } from '../../api';
import { localConfig } from '../../../Configs/localConfig';
import { errorAlert } from '../../../utils/alert';
import { getRequest } from '../../global';

//=================================================================================>
// BUSCAR LISTA DE PROPRIEDADES E SEUS TALHÕES
//<=================================================================================

//TYPES
export type Item__Talhao = {
    cod: number | null,
    nome: string | null,
    cod_propriedade: number | null,
    cod_safra: number | null,
    cod_talhao: number | null,
    area?: string,
    kml?: {
        nome: "",
        lookAt: { latitude: number, longitude: number },
        coordenadas: { latitude: number, longitude: number }[],
    }
}
export type ItemPropriedades = {
    cod: number | null,
    nome: string | null,
    status: number | null,
    cod_tipo: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    arquivo: string | null,
    area: string | null,
    matricula: string | null,
    cod_cidade: number | null,
    ccir: string | null,
    itr: string | null,
    nirf: string | null,
    inscricao_estadual: string | null,
    area_matricula: string | null,
    cod_calcario: number | null,
    cod_consultor: number | null,
    conta_nome: string | null,
    cliente_nome: string | null,
    cliente: { cod: number, nome: string }[];
    cidade: any[];
    talhao: Item__Talhao[];
    delete_time: string | null;
}

//INTERFACE
export interface PropriedadesCliente {
    itens: ItemPropriedades[]
}

export const useGetPropriedadesDoCliente = () => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`propriedade_cliente_${conta}_${codCliente}_${codSafra}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<PropriedadesCliente, Error>(queryKey, async () => {
        return api.get(`/propriedade?codConta=${conta}&codCliente=${codCliente}&talhao_codSafra=${codSafra}&embed=talhao`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de propriedades!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            // staleTime: 300000
            // staleTime: 3000000000
        }
    );

    return {
        data_propriedades: data?.itens,
        carregando_propriedades: isFetching,
        refetch_data_propriedades: refetch,
        isFetched_propriedades: isFetchedAfterMount,
        isError: isError
    };
};

//#region ATIVIDADES GERAL
//=================================================================================>
// BUSCAR LISTA DE ATIVIDADES DO TALHÃO DA PROPRIEDADE
//<=================================================================================

//TYPES
export type Item__Atividades__insumos = {
    cod: number,
    cod_insumo?: number, //incluido e usado apenas na listagem de insumos da dashboard (30/12/2025)
    ordem: number,
    dosagem: number,
    cod_tipo: number,
    cod_medida: number,
    cod_calcario: number,
    cod_biologico: number,
    cod_adjuvante: number,
    cod_inoculante: number,
    cod_tecnologia: number,
    cod_fertilizante: number,
    cod_variedade_hibrido: number,
    cod_atividade_andamento: number,
    cod_produto: number,
    observacao: string,
    quantidade: number,
    insumo_nome: string,
    composicao?: any,
    calculo_dosagem: string
    dose_inoculante: number,
    nome_medida?: string,
    maximo_acima: number,
    maximo_abaixo: number,
    // nome_aditivo: string,
    cod_aditivo: number,
    nome_tecnologia?: string, //incluido e usado apenas na listagem de insumos de relatórios  (10/04/2026)
}
export type Item__Atividades__patrimonios = {
    cod: number,
    bico: string,
    vazao: string,
    velocidade: string,
    cod_patrimonio: number,
    horimetro_final: string,
    patrimonio_nome: string,
    horimetro_inicial: string,
    quilometragem_final: string,
    quilometragem_inicial: string,
    cod_atividade_andamento: string,
}
export type Item__Atividades__finalidades = {
    cod_atividade: number,
    cod_finalidade: number,
    tipo_finalidade: string,
    descricao?: string
}
export type Item__Atividades__andamentos = {
    cod: number | null,
    cod_atividade: number | null,
    cod_usuario: number | null,
    velocidade: number | null,
    quilometragem_inicial: number | null,
    quilometragem_final: number | null,
    observacao: string | null,
    area: string | null,
    vazao: string | null,
    bico: string | null,
    operador_nome: string | null,
    horimetro_inicial: string | null,
    horimetro_final: string | null,
    umidade: string | null,
    impureza: string | null,
    rendimento: string | null,
    usuario_nome: string | null,
    insumos: Item__Atividades__insumos[],
    patrimonios: Item__Atividades__patrimonios[],
    operadores: { cod_usuario: number }[];
    data_inicio: string | null;
    data_final: string | null;
    create_user: string | null;
    create_time: string | null;
    update_user: string | null;
    update_time: string | null;
}
export type typeResumoIncomp = {
    tipoComparar: string,
    valorComparar: string,
    tipoComparado: string,
    valorComparado: string,
    tipoCompatibilidade: 2,
    valorCompatibilidade: string,
    itemCompativel: string,
    descricao: string,
    incompatibilidadeAnulada: boolean,
    observacao: string,
    codAlerta: number
}
export type Item__Atividades = {
    cod?: number | null,
    cod_tipo?: number | null,
    cod_operacao?: number | null,
    cod_talhao?: number | null,
    data_inicio?: string | null,
    data_final?: string | null,
    densidade_semeadura?: string | null,
    tipo_fertilizacao?: number | null,
    porcentagem_executada?: number | null,
    tipo_adubacao?: number | null,
    tipo_plantio?: number | null,
    tipo_tratamento_semente?: number | null,
    tipo_inoculacao?: number | null,
    cod_atividade?: number | null,
    dias?: number | string | null,
    velocidade_trabalho?: number | null,
    observacao?: string | null,
    area_executada?: string | null,
    cod_usuario?: number | null,
    cod_conta?: number | null,
    cod_cliente?: number | null,
    create_time?: string | null,
    update_time?: string | null,
    delete_time?: string | null,
    create_user?: string | null,
    update_user?: string | null,
    cod_referencia?: number | null,
    tipo_aplicacao?: number | null,
    descricao?: string | null,
    resumo_compatibilidade?: typeResumoIncomp[] | null,
    concluido?: boolean | null,
    area?: string | null,
    cod_safra?: number | null,
    safra_nome?: string | null,
    cod_cultura?: number | null,
    cultura_nome?: string | null,
    tipo_operacao?: string | null,
    porcentagem_remonte?: number,
    finalidades?: Item__Atividades__finalidades[],
    andamentos?: Item__Atividades__andamentos[],
    tipo_historico?: string,
    estadios_cultura?: { cod_atividade: number, cod_cultura: number, cod_estadio_cultura: number, estadio_cultura_nome: string }[],
    propriedade_nome?: string;
    cod_propriedade?: number;
    ref_agrupar?: string;
    titulo_operacao?: string;
    dados_atividade?: any;
    finalidades_executadas?: any[],
    is_concluido?: boolean,
    oculto?: boolean,
    data_conclusao?: string,
    tipo_referencia?: number,
    tipo_filtro?: string,
    nome_talhao?: string,
    nome_subarea?: string,
    nome_subcard?: string,
    patrimonios?: any,
    tipo_referencia_nome?: string,
}

//INTERFACE
export interface Atividades {
    itens: Item__Atividades[]
}

export const useGetAtividadesGerais = () => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`atividade_talhao_${conta}_${codCliente}_${codSafra}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Atividades, Error>(queryKey, async () => {

        const params_url = () => {
            return `&codSafra=${codSafra}`;
        }
        return api.get(`atividade-campo?codConta=${conta}&codCliente=${codCliente}${params_url()}&embed=andamentos,patrimonios,estadios_cultura,insumos,finalidades&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de atividades!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            // staleTime: 600000000,
            // staleTime: 60000,
        }
    );

    return {
        data_atividades: data?.itens,
        carregando_atividades: isFetching,
        refetch_data_atividades: refetch,
        isFetched_atividades: isFetchedAfterMount,
        isError_atividades: isError
    };
};
//#endregion
//#region ATIVIDADES POR TALHÃO
//=================================================================================>
// BUSCAR LISTA DE ATIVIDADES DO TALHÃO DA PROPRIEDADE
//<=================================================================================

//TYPES
//INTERFACE
export interface Atividades {
    itens: Item__Atividades[]
}

export const useGetAtividadesPorTalhao = (cod_propriedade?: number, cod_talhao?: number, cod_subarea?: number, enabled?: boolean, staleTime?: number) => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`atividade_talhao_${conta}_${codCliente}_${cod_talhao}_${cod_subarea}_${codSafra}_${cod_propriedade ?? 'sem'}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Atividades, Error>(queryKey, async () => {
        let cod_talhao_ou_subarea = cod_subarea ?? cod_talhao;
        const params_url = () => {
            if (cod_propriedade && cod_talhao_ou_subarea) {
                return `&codPropriedade=${cod_propriedade}&codTalhao=${cod_talhao_ou_subarea}&codSafra=${codSafra}`;
            }
            else if (cod_propriedade && !cod_talhao_ou_subarea) {
                return `&codPropriedade=${cod_propriedade}&codSafra=${codSafra}`;
            }
            return `&codSafra=${codSafra}`;
        }
        return api.get(`atividade-campo?codConta=${conta}&codCliente=${codCliente}${params_url()}&embed=andamentos,patrimonios,estadios_cultura,insumos,finalidades&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de atividades!');
            })
    },
        {
            enabled: enabled,
            refetchOnWindowFocus: false,
            staleTime: staleTime ?? 600000000,
            // staleTime: 60000,
        }
    );

    return {
        data_atividades: data?.itens,
        carregando_atividades: isFetching,
        refetch_data_atividades: refetch,
        isFetched_atividades: isFetchedAfterMount,
        isError_atividades: isError
    };
};
//#endregion

//#region HISTÓRICO ATVs
//=================================================================================>
// BUSCAR LISTA DE ATIVIDADES DO TALHÃO DA PROPRIEDADE
//<=================================================================================

//TYPES
export type Item__HistoricoAtividades = {
    cod?: number | null,
    cod_tipo?: number | null,
    cod_operacao?: number | null,
    cod_talhao?: number | null,
    data_inicio?: string | null,
    data_final?: string | null,
    densidade_semeadura?: string | null,
    tipo_fertilizacao?: number | null,
    porcentagem_executada?: number | null,
    tipo_adubacao?: number | null,
    tipo_plantio?: number | null,
    tipo_tratamento_semente?: number | null,
    tipo_inoculacao?: number | null,
    cod_atividade?: number | null,
    dias?: number | string | null,
    velocidade_trabalho?: number | null,
    observacao?: string | null,
    area_executada?: string | null,
    cod_usuario?: number | null,
    cod_conta?: number | null,
    cod_cliente?: number | null,
    create_time?: string | null,
    update_time?: string | null,
    delete_time?: string | null,
    create_user?: string | null,
    update_user?: string | null,
    cod_referencia?: number | null,
    tipo_aplicacao?: number | null,
    descricao?: string | null,
    resumo_compatibilidade?: typeResumoIncomp[] | null,
    concluido?: boolean | null,
    area?: string | null,
    cod_safra?: number | null,
    safra_nome?: string | null,
    cod_cultura?: number | null,
    cultura_nome?: string | null,
    tipo_operacao?: string | null,
    porcentagem_remonte?: number,
    tipo_historico?: string,
    ref_agrupar?: string
}

//INTERFACE
export interface HistoricoAtividades {
    itens: Item__HistoricoAtividades[]
}

export const useGetHistoricoAtividadesPorTalhao = (cod_talhao: number, cod_subarea?: number) => {

    let { conta, codCliente } = localConfig();

    const queryKey: any = [`historico_atividade_talhao_${conta}_${codCliente}_${cod_talhao}`];

    //`frontusage=historico` não existe na API. É passado apenas para facilitar o debug no front para saber qual initiator chamou a rota
    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<HistoricoAtividades, Error>(queryKey, async () => {
        let cod_talhao_ou_subarea = cod_subarea ?? cod_talhao;
        return api.get(`atividade-campo?codConta=${conta}&codCliente=${codCliente}&codTalhao=${cod_talhao_ou_subarea}&deleted=true&frontusage=historico`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de atividades!');
            })
    },
        {
            enabled: false,
            refetchOnWindowFocus: false,
            // staleTime: 600000000,
            // staleTime: 60000,
        }
    );

    return {
        data_historico_atividades: data?.itens,
        carregando_historico_atividades: isFetching,
        refetch_data_historico_atividades: refetch,
        isFetched_historico_atividades: isFetchedAfterMount,
        isError_historico_atividades: isError
    };
};
//#endregion

//#region FINALIDADES
//=================================================================================>
// BUSCAR LISTA DE FINALIDADES
//<=================================================================================

//TYPES
export type Item__Finalidades = {
    cod: number | null,
    nome: string | null,
    cod_tipo_geral: number | null,
    ordem: number | null,
    create_time: string | null,
    update_time: string | null,
    delete_time: string | null,
    tipo_geral_nome?: string | null
}

//INTERFACE
export interface Finalidades {
    itens: Item__Finalidades[]
}

export const useGetFinalidades = () => {

    const queryKey: any = [`finalidades`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Finalidades, Error>(queryKey, async () => {
        return api.get(`tipos-sistema?&codTipo=108&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de finalidades!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_finalidades: data?.itens,
        carregando_finalidades: isFetching,
        refetch_data_finalidades: refetch,
        isFetched_finalidades: isFetchedAfterMount,
        isError_finalidades: isError
    };
};
//#endregion

//#region PRODUTOS
//=================================================================================>
// BUSCAR LISTA DE INSUMOS PRODUTO
//<=================================================================================

//TYPES
export type AtvProdutos__Composicao = {
    cod: number,
    cod_produto: number,
    cod_ativo: number,
    concentracao: string,
    cod_replica: number,
    produto_nome: string,
    ativo_nome: string,
    ativo: [
        {
            cod: number,
            nome: string,
            cod_categoria_produto: number,
            cod_grupo_quimico: number,
            cod_classe_quimica: number,
            cod_grupo: number,
            cod_modo_acao: number,
            cod_local_acao: number,
            cod_mecanismo_acao: number,
            cod_classe_agronomica: number,
            classe_agronomica_nome: string,
            grupo_quimico_nome: string,
            grupo_nome: string,
            classe_quimica_nome: string,
            modo_acao_nome: string,
            local_acao_nome: string,
            mecanismo_acao_nome: string,
            local_mecanismo_acao: string
        }
    ]
}
export type Item__AtvProdutos = {
    cod: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    cod_categoria_produto: number | null,
    cod_fabricante: number | null,
    nome: string | null,
    descricao: string | null,
    create_time: string | null,
    update_time: string | null,
    delete_time: string | null,
    cod_formulacao: number | null,
    adjuvante: number | null,
    cod_tipo_adjuvante: number | null,
    observacao: string | null,
    cod_medida_aplicacao: number | null,
    create_user: string | null,
    update_user: string | null,
    delete_user: string | null,
    cod_classe_agronomica: number | null,
    cod_replica: number | null,
    cod_variedade_hibrido: number | null,
    cod_fertilizante: number | null,
    cod_tecnologia: number | null,
    fabricante_nome: string | null,
    categoria_produto_nome: string | null,
    classe_agronomica_nome: string | null,
    composicao: AtvProdutos__Composicao[]
}

//INTERFACE
export interface AtvProdutos {
    itens: Item__AtvProdutos[]
}

export const useGetAtvProdutos = (cod_cultura: number) => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`recomendacao_insumo_agricola_${conta}_${cod_cultura}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvProdutos, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `codCliente=${codCliente}` : '';
        return api.get(`recomendacao/insumo-agricola?codConta=${conta}&codCultura=${cod_cultura}&codCategoriaProduto=1&embed=composicao&pagination=-1&${needCodCliente}`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de produtos!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_produtos: data?.itens,
        carregando_produtos: isFetching,
        refetch_data_produtos: refetch,
        isFetched_produtos: isFetchedAfterMount,
        isError_produtos: isError
    };
};
//#endregion

//#region FERTILIZANTES
//=================================================================================>
// BUSCAR LISTA DE INSUMOS FERTILIZANTE
//<=================================================================================

//TYPES
export type Item__AtvFertilizantes = {
    cod: number | null,
    nome: string | null,
    cod_formulacao: number | null,
    densidade: "1.00",
    cod_marca: number | null,
    n: string | null,
    p: string | null,
    k: string | null,
    ca: string | null,
    mg: string | null,
    s: string | null,
    b: string | null,
    cu: string | null,
    fe: string | null,
    mn: string | null,
    zn: string | null,
    co: string | null,
    mo: string | null,
    ni: string | null,
    si: string | null,
    aminoacido: string | null,
    indice_salino: string | null,
    observacao: string | null,
    create_time: string | null,
    update_time: string | null,
    delete_time: string | null,
    cod_conta: number | null,
    create_user: string | null,
    update_user: string | null,
    se: string | null,
    extrato_de_alga_descricao: string | null,
    aminoacido_descricao: string | null,
    hormonio_regulador: string | null,
    hormonio_regulador_descricao: string | null,
    indutor_resistencia: string | null,
    indutor_resistencia_descricao: string | null,
    biologicos: string | null,
    biologicos_descricao: string | null,
    solubilidade: string | null,
    ponto_deliquescencia: string | null,
    extrato_de_alga: string | null,
    cod_replica: number | null,
    marca_nome: string | null,
    tipo_formulacao_nome: string | null
}

//INTERFACE
export interface AtvFertilizantes {
    itens: Item__AtvFertilizantes[]
}

export const useGetAtvFertilizante = (cod_cultura: number) => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_fertilizante_${conta}_${cod_cultura}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvFertilizantes, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `codCliente=${codCliente}` : '';
        return api.get(`fertilizante?codConta=${conta}&pagination=-1&${needCodCliente}`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de fertilizantes!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_fetilizantes: data?.itens,
        carregando_fetilizantes: isFetching,
        refetch_data_fetilizantes: refetch,
        isFetched_fetilizantes: isFetchedAfterMount,
        isError_fetilizantes: isError
    };
};
//#endregion

//#region ADJUVANTES
//=================================================================================>
// BUSCAR LISTA DE INSUMOS FERTILIZANTE
//<=================================================================================

//TYPES
export type Item__AtvAdjuvantes = {
    cod: number | null,
    cod_conta: number | null,
    cod_cliente: number | null,
    cod_categoria_produto: number | null,
    cod_fabricante: number | null,
    nome: string | null,
    descricao: string | null,
    cod_formulacao: number | null,
    adjuvante: number | null,
    cod_tipo_adjuvante: number | null,
    observacao: string | null,
    cod_medida_aplicacao: number | null,
    cod_classe_agronomica: number | null,
    cod_replica: number | null,
    cod_variedade_hibrido: number | null,
    cod_fertilizante: number | null,
    cod_tecnologia: number | null,
    acao_ph_calda: string | null,
    fabricante_nome: string | null,
    categoria_produto_nome: string | null,
    classe_agronomica_nome: string | null,
    nome_medida_aplicacao: string | null,
    fertilizante: any[],
    propriedades_adjuvante?: {
        cod: number | null,
        cod_adjuvante: number | null,
        cod_propriedade_adjuvante: number | null,
        tipo_propriedade_adjuvante: number | null,
        adjuvante_nome: string | null,
        propriedade_adjuvante_nome: string | null,
    }[],
    composicao?: {
        cod: number,
        cod_produto: number,
        cod_ativo: number,
        concentracao: string,
        cod_replica: number,
        cod_tipo_medida: number,
        produto_nome: string,
        ativo_nome: string,
        nome_tipo_medida: string,
        ativo: {
            cod: number,
            nome: string,
            cod_categoria_produto: number,
            cod_grupo_quimico: number,
            cod_classe_quimica: number,
            cod_grupo: number,
            cod_modo_acao: number,
            cod_local_acao: number,
            cod_mecanismo_acao: number,
            cod_classe_agronomica: number,
            classe_agronomica_nome: string,
            grupo_quimico_nome: string,
            grupo_nome: string,
            classe_quimica_nome: string,
            modo_acao_nome: string,
            local_acao_nome: string,
            mecanismo_acao_nome: string,
            local_mecanismo_acao: string,
        }[]
    }[],
    doses: {
        cod: number,
        cod_cultura: number,
        cod_adjuvante: number,
        dose: string,
        min_dose: number | string,
        max_dose: number | string,
        cod_replica: number,
        adjuvante_nome: string,
        cultura_nome: string
    }[]
}

//INTERFACE
export interface AtvAdjuvantes {
    itens: Item__AtvAdjuvantes[]
}

export const useGetAtvAdjuvantes = () => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_adjuvante_${conta}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvAdjuvantes, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `codCliente=${codCliente}` : '';
        return api.get(`recomendacao/adjuvante?codConta=${conta}&pagination=-1&${needCodCliente}`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de adjuvantes!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_adjuvantes: data?.itens,
        carregando_adjuvantes: isFetching,
        refetch_data_adjuvantes: refetch,
        isFetched_adjuvantes: isFetchedAfterMount,
        isError_adjuvantes: isError
    };
};
//#endregion

//#region CALCÁRIOS
//=================================================================================>
// BUSCAR LISTA DE INSUMOS CALCÁRIOS
//<=================================================================================

//TYPES
export type Item__AtvCalcario = {
    cod: number,
    cod_conta: number,
    cod_cliente: number,
    cod_categoria_produto: number,
    cod_fabricante: number,
    nome: string,
    descricao: string,
    cod_formulacao: number,
    adjuvante: number,
    cod_tipo_adjuvante: number,
    observacao: string,
    cod_medida_aplicacao: number,
    cod_classe_agronomica: number,
    cod_replica: number,
    cod_variedade_hibrido: number,
    cod_fertilizante: number,
    cod_tecnologia: number,
    acao_ph_calda: any,
    cod_fornecedor: number,
    fabricante_nome: string,
    categoria_produto_nome: string,
    classe_agronomica_nome: string,
    nome_medida_aplicacao: string,
    fornecedor_nome: string,
    ca_o: string,
    mg_o: string,
    pn: string,
    re: string,
    prnt: string,
    peneira_fundo: string,
    fertilizante: any[]
}

//INTERFACE
export interface AtvCalcario {
    itens: Item__AtvCalcario[]
}

export const useGetAtvCalcarios = () => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_calcario_${conta}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvCalcario, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `&codCliente=${codCliente}` : '';
        return getRequest(`recomendacao/insumo-calcario?codConta=${conta}${needCodCliente}`)
        // return api.get(`recomendacao/insumo-calcario?codConta=${conta}&pagination=-1&${needCodCliente}`)
        //     .then((response): any => {
        //         return response.data
        //     })
        //     .catch((error) => {
        //         errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de calcários!');
        //     })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_calcarios: data?.itens,
        carregando_calcarios: isFetching,
        refetch_data_calcarios: refetch,
        isFetched_calcarios: isFetchedAfterMount,
        isError_calcarios: isError
    };
};
//#endregion

//#region INCULANTES
//=================================================================================>
// BUSCAR LISTA DE INSUMOS CALCÁRIOS
//<=================================================================================

//TYPES
export type Item__AtvInoculante = {
    cod: number,
    cod_conta: number
    cod_cliente: number
    cod_categoria_produto: number
    cod_fabricante: number
    nome: string,
    descricao: string,
    cod_formulacao: number
    adjuvante: number
    cod_tipo_adjuvante: number
    observacao: string,
    cod_medida_aplicacao: number,
    cod_classe_agronomica: number,
    cod_replica: number,
    cod_variedade_hibrido: number,
    cod_fertilizante: number,
    cod_tecnologia: number,
    acao_ph_calda: number,
    cod_fornecedor: number,
    fabricante_nome: string,
    categoria_produto_nome: string,
    classe_agronomica_nome: string,
    nome_medida_aplicacao: string,
    fornecedor_nome: string,
    fertilizante: any[],
    parametros_bioinsumo: any[]
}

//INTERFACE
export interface AtvInoculante {
    itens: Item__AtvInoculante[]
}

export const useGetAtvInoculantes = () => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_inoculantes_${conta}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvInoculante, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `&codCliente=${codCliente}` : '';
        return getRequest(`recomendacao/bioinsumo?codConta=${conta}&codCategoriaProduto=6${needCodCliente}&embed=bioinsumo`)
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_inoculantes: data?.itens,
        carregando_inoculantes: isFetching,
        refetch_data_inoculantes: refetch,
        isFetched_inoculantes: isFetchedAfterMount,
        isError_inoculantes: isError
    };
};
//#endregion

//#region BIOLOGICOS
//=================================================================================>
// BUSCAR LISTA DE INSUMOS BIOLOGICOS
//<=================================================================================

export const useGetAtvBiologicos = () => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_biologicos_${conta}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvInoculante, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `&codCliente=${codCliente}` : '';
        return getRequest(`recomendacao/bioinsumo?codConta=${conta}&codCategoriaProduto=5${needCodCliente}`)
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_biologicos: data?.itens,
        carregando_biologicos: isFetching,
        refetch_data_biologicos: refetch,
        isFetched_biologicos: isFetchedAfterMount,
        isError_biologicos: isError
    };
};
//#endregion

//#region ADITIVOS
//=================================================================================>
// BUSCAR LISTA DE INSUMOS ADITIVOS
//<=================================================================================

//TYPES
export type Item__AtvAditivo = {
    cod: number,
    cod_conta: number,
    cod_cliente: null,
    cod_categoria_produto: number,
    cod_fabricante: number,
    nome: string,
    descricao: string,
    create_time: string,
    update_time: string,
    delete_time: string,
    cod_formulacao: number,
    adjuvante: number,
    cod_tipo_adjuvante: number,
    observacao: string,
    cod_medida_aplicacao: number,
    create_user: string,
    update_user: string,
    delete_user: string,
    cod_classe_agronomica: number,
    cod_replica: number,
    cod_variedade_hibrido: number,
    cod_fertilizante: number,
    cod_tecnologia: null,
    acao_ph_calda: null,
    cod_fornecedor: null,
    tipo_formulacao: number,
    tipo_aditivo: number,
    fabricante_nome: string,
    categoria_produto_nome: string,
    classe_agronomica_nome: string,
    nome_medida_aplicacao: string,
    fornecedor_nome: string,
    fertilizante: any[],
    doses: any[]
}

//INTERFACE
export interface AtvAditivo {
    itens: Item__AtvAditivo[]
}
export const useGetAtvAditivos = () => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_aditivos_${conta}_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvAditivo, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `&codCliente=${codCliente}` : '';
        return getRequest(`recomendacao/aditivo?codConta=${conta}&embed=aditivo${needCodCliente}`)
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 600000
        }
    );

    return {
        data_aditivos: data?.itens,
        carregando_aditivos: isFetching,
        refetch_data_aditivos: refetch,
        isFetched_aditivos: isFetchedAfterMount,
        isError_aditivos: isError
    };
};
//#endregion

//#region VARIEDADE/HIBRIDO
//=================================================================================>
// BUSCAR LISTA DE INSUMOS VAERIEDADE HIBRIDO E SUAS TECNOLOGIAS
//<=================================================================================

//TYPES
export type typeTecnologia = {
    cod_variedade_hibrido: number | null,
    cod_tecnologia: number | null,
    create_time: string | null,
    update_time: string | null,
    delete_time: string | null,
    create_user: string | null,
    update_user: string | null,
    variedade_hibrido_nome: string | null,
    tecnologia_nome: string | null
}
export type Item__AtvVariedadeHibrido = {
    cod: number | null,
    cod_conta: number | null,
    cod_cultura: number | null,
    cod_nivel_investimento: number | null,
    nome: string | null,
    empresa_obtentora: string | null,
    observacao: string | null,
    cod_classificacao: number | null,
    valor_classificacao: string | null
    cod_opcao_classificacao: number | null,
    create_time: string | null
    update_time: string | null
    delete_time: string | null
    create_user: string | null
    update_user: string | null
    cod_replica: number | null,
    cultura_nome: string | null
    tipo_classificacao: string | null
    tipo_opcao_classificacao: string | null
    nivel_investimento: string | null,
    tecnologias: typeTecnologia[]
}

//INTERFACE
export interface AtvVariedadeHibrido {
    itens: Item__AtvVariedadeHibrido[]
}

export const useGetAtvVariedadeHibrido = (cod_cultura: number) => {

    let { conta, codCliente, acesso } = localConfig();
    let is_cliente = acesso === 'cliente' ? `codCliente=${codCliente}` : 'is_consultoria';

    const queryKey: any = [`atv_variedae_hibrido_${conta}_${cod_cultura}_tecnologia_${is_cliente}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<AtvVariedadeHibrido, Error>(queryKey, async () => {
        let needCodCliente = acesso === 'cliente' ? `codCliente=${codCliente}` : '';
        return api.get(`variedade-hibrido?codConta=${conta}&codCultura=${cod_cultura}&embed=tecnologias&pagination=-1&${needCodCliente}`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de variedades!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 100
            // staleTime: 600000
        }
    );

    return {
        data_variedade_hibrido: data?.itens,
        carregando_variedade_hibrido: isFetching,
        refetch_data_variedade_hibrido: refetch,
        isFetched_variedade_hibrido: isFetchedAfterMount,
        isError_variedade_hibrido: isError
    };
};
//#endregion


//#region UNIDADES DE MEDIDAS
//=================================================================================>
// BUSCAR TIPOS DE MEDIDA (UNIDADES DE MEDIDA)
//<=================================================================================

//TYPES
export type Item__UnidadeMedida = {
    cod: number,
    nome: string,
    cod_tipo: number,
    tipo_nome: "Líquido"
}

//INTERFACE
export interface UnidadeMedida {
    itens: Item__UnidadeMedida[]
}

export const useGetUnidadesDeMedidas = () => {

    const queryKey: any = [`tipos_medidas_atvividades`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<UnidadeMedida, Error>(queryKey, async () => {
        return api.get(`tipos-medida?pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter lista de unidadaes de medidas!');
            })
    },
        {
            enabled: true,
            refetchOnWindowFocus: false,
            staleTime: 3600000 //1 hora
        }
    );

    return {
        data_unidades_medida: data?.itens,
        carregando_unidades_medida: isFetching,
        refetch_data_unidades_medida: refetch,
        isFetched_unidades_medida: isFetchedAfterMount,
        isError_unidades_medida: isError
    };
};
//#endregion

//INTERFACE
type typeEmergencia = {
    cod: number,
    cod_conta: number,
    cod_propriedade: number,
    area: string,
    arquivo: string,
    nome: string,
    status: number,
    kml: {
        nome: "",
        lookAt: { latitude: -23.0617654, longitude: -55.2772449 },
        coordenadas: { latitude: -23.0677646, longitude: -55.2736455 }[]
    },
    cod_safra: number,
    cod_talhao: number,
    area_anterior: string,
    observacao: string,
    motivo: string,
    confirmacao: null,
    dias_apos_plantio: number,
    data_emergencia_plantio: string,
    propriedade_nome: string,
    safra_nome: string,
    cod_cultura: number,
    arquivo_url: string,
}

export interface Emergencia {
    itens: typeEmergencia[]
}

export const useGetDataEmergencia = (cod_talhao: number) => {

    let { conta, codCliente, codSafra } = localConfig();

    const queryKey: any = [`emergencia_talhao-safra_${conta}_${codCliente}_${codSafra}_${cod_talhao}`];

    const { data, isFetching, refetch, isFetchedAfterMount, isError } = useQuery<Emergencia, Error>(queryKey, async () => {
        return api.get(`talhao-safra?codConta=${conta}&codCliente=${codCliente}&codSafra=${codSafra}&cod=${cod_talhao}&pagination=-1`)
            .then((response): any => {
                return response.data
            })
            .catch((error) => {
                errorAlert(error?.response?.data?.error ?? 'Falha ao obter data de emergência!');
            })
    },
        {
            enabled: false,
            refetchOnWindowFocus: false,
            staleTime: 2000000000,
            // staleTime: 200000
        }
    );

    return {
        data_emergencia: data?.itens?.[0],
        carregando_emergencia: isFetching,
        refetch_emergencia: refetch,
        isFetched_emergencia: isFetchedAfterMount,
        isError_emergencia: isError
    };
};
//#endregion